import InstanceType from "rwb/pages/project/types/enums/instanceType";
import { useStickyFetcher } from "~/hooks/useFetcher";

const { VITE_RWB_API } = import.meta.env;

const useComputePrices = () => {
  return useStickyFetcher<{
    instance_types: Partial<Record<InstanceType, number>>;
    volume_sizes: Record<string, number>;
  }>(`${VITE_RWB_API}/resources/instance-prices`);
};

export default useComputePrices;
